import { HTTP, HTTP_FIREBASE_SHORTLINK, HTTP_WITHOUT_HEADER } from '../../utils'
import { getItem } from '../../storage'

export const getInstitutionMetaInfoForSelfRegistration = (uuid) => {
  return HTTP_WITHOUT_HEADER().get('institution/selfRegistrationMetaInfo/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const populateProgramTracking = (programGuideCode) => {
  return getItem('token').then(token => {
    let url = '/entity/tracking/' + programGuideCode
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}
export const logDashboardActivity = (activity, token) => {
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return getItem('token').then(token => {
    return HTTP_WITHOUT_HEADER().put('entity/log?token=' + token, JSON.stringify(activity), config)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getCurrentEnvironment = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/configuration')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getInstitutionDetails = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/institution/' + uuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getInstitutionPackages = (uuid, isAggregated) => {
  let url = '/institution/' + uuid + '/package?isAggregated='
  url += isAggregated ? 'true' : 'false'
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getLibrariesForUser = (userId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('learningspace/user?userUuid=' + userId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const populatePlanningStream = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('entity/planningstream')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const populateEnrolledCourses = (pagingOptions) => {
  const url = 'deliverycontext/enrolled?page=' + pagingOptions.page + '&count=' + pagingOptions.count
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getCourseDetail = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('deliverycontext/' + uuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}
export const getAIContents = (courseId) => {
return getItem('token').then(token => { 
  return HTTP(token).get('/deliverycontext/' + courseId + '/aicontent')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
  })
}
export const getCompetencyLogic = (courseId, type) => {
return getItem('token').then(token => { 
  return HTTP(token).get('/competencyLogic/course/' + courseId + '/type/'+type)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
  })
}
export const askSuggestForLast = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('suggest/course/' + uuid + '/lastaction')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getClassSummaryWithPeer = (entityId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('class/' + entityId + '/peer')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getCompetencySummary = (entityId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/' + entityId + '/competencySummary')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getMicroCompetencySummary = (entityId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/' + entityId + '/mcSummary')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCourseTopics = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).put('deliverycontext/' + uuid + '/withPlan')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLearningTopicDetails = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('topic/' + uuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCourseCompetencies = (courseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/' + courseId + '/competencySummary')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLearningContentDetails = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('learningcontent/' + uuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}
export const populateAttemptAIReport = (activityId, sessionId, courseId, userId) => {
return getItem('token').then(token => {
  const hostname = window.location.hostname
  var url = 'attempt/summary/' + activityId + '?sessionId=' + sessionId + '&courseId=' + courseId + '&hostname=' + hostname
  if (userId) {
    url += '&userId=' + userId
  }
  return HTTP(token).get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
  })
}
export const getEntityActivity = (courseId, entityId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/' + courseId + '/competencySummary/entity/' + entityId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getEntityCompetencySummary = (courseId, entityId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/' + courseId + '/competencySummary/entity/' + entityId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const askSuggestForNext = (courseUuid, entityUuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('suggest/course/' + courseUuid + '/next/' + entityUuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
      return {error: true}
    })
  })
}

export const getCareerDetail = (name) => {
  return getItem('token').then(token => {
    return HTTP(token).get('career/searchByName?name=' + name)
    .then(response => {
      let careers = response.data
      return (careers && careers.length > 0) ? careers[0] : null
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const populateCareerByCodeAndSource = (code, source) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/career/getByCode/' + code + '?source=' + source)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getBlackboardCourseAccess = (lmsCourseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('blackboardActivity/courseActivity/' + lmsCourseId + '?activityType=COURSE_ACCESS')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getBlackboardContentAccess = (lmsCourseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('blackboardActivity/courseActivity/' + lmsCourseId + '?activityType=CONTENT_ACCESS')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getBlackboardGradeActivity = (lmsCourseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('blackboardActivity/gradeActivity/' + lmsCourseId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getBlackboardAggregatedGradeActivity = (lmsCourseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('blackboardActivity/aggregatedGradeActivity/' + lmsCourseId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getBlackboardAnnouncements = (lmsCourseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('blackboardActivity/announcement?lmsCourseId=' + lmsCourseId + '&announcementType=C')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getUserAdvisor = (uuid) => {
  return getItem('token').then(token => {
    var url = '/user/advisor/' + uuid
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getInstitutionMetaInfo = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('institution/metaInfo')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getQuestionsForGroup = (group) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/qa/group/' + group)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const saveUserProfileAndAnswer = (data) => {
  return getItem('token').then(token => {
    return HTTP(token).post('/qa/saveUserProfileAndAnswer', data)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getLearnerDashboardState = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/custom/learner/dashboard')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getLearnerEnrollmentData = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/custom/learner/enrollment')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getLearnerEnrollmentDataForCode = (programCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/programguide/learnerEnrolledProgram/code/'+programCode)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getNextCalendarEvent = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/calendarEvent/nextCalendarEvent')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}
export const getFeedsForStudent = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/feed/all')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getRecommendationsForStudent = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/channel/student/myChannels/recommendations')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}
export const populateQuickLinks = (type) => {
  return getItem('token').then(token => {
    return HTTP(token).get('quicklink?type='+type)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getNotificationsForStudent = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/channel/student/myChannels/notifications')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getAllCalendarEvents = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/calendarEvent/fetchAll')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getAllChannels = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/channel/myChannels')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getCoursesWithChannel = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('deliverycontext/coursesWithChannel')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCourseSectionChannel = (courseSectionId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('channel/courseSection/' + courseSectionId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const uploadFileAttachment = (data) => {
  let url = 'v1/shortLinks?key=AIzaSyBvbgnksPKifXn5ymgQ6ahfcITv25ULGRc'
  return HTTP_FIREBASE_SHORTLINK().post(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const createChannel = (data) => {
  let url = '/channel'
  if (data.uuid) {
    url += '/' + data.uuid
  }
  return getItem('token').then(token => {
    return HTTP(token).put(url, data)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error: ' + e)
    })
  })
}

export const getDirectChannelUsers = (courseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/deliverycontext/directChannelUsers?courseId=' + courseId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error: ' + e)
    })
  })
}

export const getDirectChannelPeerMap = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('user/fetchDirectChannelPeerMap')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const addToDirectChannelPeerMap = (selectedUsers) => {
  return getItem('token').then(token => {
    return HTTP(token).put('user/addToDirectChannelPeerMap', selectedUsers)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const updateDirectChannelPeerMap = (selectedUserId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('user/' + selectedUserId + '/updateDirectChannelPeerMap')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const createStudyGroup = (channelId, data) => {
  let url = '/channel/' + channelId + '/createStudyGroup'
  return getItem('token').then(token => {
    return HTTP(token).put(url, data)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error: ' + e)
    })
  })
}

export const deleteStudyGroup = (channelId, groupId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/channel/' + channelId + '/deleteStudyGroup/' + groupId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error: ' + e)
    })
  })
}

export const getParticipantDisplayNames = (uuids) => {
  return getItem('token').then(token => {
    return HTTP(token).put('user/displayNamesForSelectedUsers', uuids)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error: ' + e)
    })
  })
}

export const getAllBadWords = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/badWord/list')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error: ' + e)
    })
  })
}

export const populateStreamWithStructure = (programCode) => {
  let url = '/entity/program/' + programCode + '?isPopulateStructure=true'
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}
export const getStreamLeafForCourse = (programCode, originUuid) => {
  let url = '/entity/program/'+programCode+'/leaf/'+originUuid
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}
export const populateStreamWithStructureSummary = (programCode) => {
  let url = '/entity/program/'+programCode+'/summary?isPopulateStructure=true'
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getInstitutionProducts = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('institutionProduct/all')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getUserSubscriptions = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/user/subscriptions')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getUserPaymentMethods = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/user/paymentMethods')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const putCreateUserPaymentMethod = (paymentMethodObj) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/user/paymentMethods/create', paymentMethodObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const putCreateUserSubscription = (userSubscriptionObj) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/user/subscriptions/create', userSubscriptionObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const putCancelUserSubscription = (subscriptionUuid) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/user/subscriptions/' + subscriptionUuid + '/delete')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getUserTransactions = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/transaction/userTransactions')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getAllUserAccounts = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/user/all/accounts')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const updateUserProfileResume = (uuid, resume) => {
  const url = '/user/updateProfileResume/' + uuid
  return getItem('token').then(token => {
    return HTTP(token).put(url, resume)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const updateUserProfileResumeAsPrimary = (uuid, id) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/user/updateProfileResumeAsPrimary/' + uuid + '/' + id)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const deleteUserProfileResume = (uuid, id) => {
  return getItem('token').then(token => {
    return HTTP(token).delete('/user/deleteProfileResume/' + uuid + '/' + id)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCheckTransactionValidity = (programId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/transaction/userTransaction/' + programId + '/validity')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getAllPurchasePrograms = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/transaction/all/program/')
    .then(res => { 
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })

}


// WEBPACK FOOTER //
// ./src/app/dashboard/api.js